import { HttpResponse, HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs';

/**
 * Finds and replaces all ISO8601 formatted date strings with actual JavaScript date objects.
 * @returns The body of the response is returned by all ISO8601 formatted date strings will
 * have been converted to JavaScript Date objects.
 */
export const iso8601ToJsonDateHttpInterceptor = () => {
  const iso8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;
  //const dateOnly = /^\d{4}-\d{2}-\d{2}$/;

  const convertToDate = (body: unknown) => {
    if (body === null || body === undefined || typeof body !== 'object') {
      return;
    }

    const record = body as Record<string, unknown>;
    for (const key of Object.keys(record)) {
      const value = record[key];
      switch (typeof value) {
        case 'string':
          if (iso8601.test(value)) {
            // The value from the server is coming over as UTC
            // 2023-12-28T00:00:00Z => Wed Dec 27 2023 18:00:00 GMT-0600 (Central Standard Time)
            record[key] = new Date(value);
            //} else if (dateOnly.test(value)) {
            //   body[key] = new Date(value).setHours(0, 0, 0, 0);
          }
          break;

        case 'object':
          convertToDate(value);
          break;
      }
    }
  };

  const interceptor: HttpInterceptorFn = (req, next) => {
    return next(req).pipe(
      tap({
        next: (response) => {
          if (response !== null && response instanceof HttpResponse) {
            const body = response.body;
            convertToDate(body);
          }
        }
      })
    );
  };

  return interceptor;
};
